import { IdType, PatientExternalIdDto } from "@accurx/api/ticket";
import { PatientExternalId } from "@accurx/native";
import { Log } from "@accurx/shared";
import { isInstance } from "domains/concierge/internal/util/isInstance";

const mapPatientExternalIdToPatientSummaryExternalId = (
    dto: PatientExternalIdDto,
): PatientExternalId | undefined => {
    switch (dto.type) {
        case IdType.NhsNumber:
            return {
                type: "NhsNumber",
                value: dto.value,
            };
        case IdType.Emis:
            return {
                type: "Emis",
                value: dto.value,
            };

        case IdType.SystmOne:
            return {
                type: "SystmOne",
                value: dto.value,
            };
        case IdType.Vision:
            return {
                type: "Vision",
                value: dto.value,
            };
        case IdType.ChiNumber:
            return {
                type: "ChiNumber",
                value: dto.value,
            };
        case IdType.Hospital:
            return {
                type: "Hospital",
                value: dto.value,
            };
        case IdType.UnmatchedNhsNumber:
            return {
                type: "UnmatchedNhsNumber",
                value: dto.value,
            };
        case IdType.Dummy:
            return {
                type: "Dummy",
                value: dto.value,
            };

        case IdType.None:
            Log.warn(
                "Received unexpected IdType.None when mapping patient external ids.",
            );
            return undefined;
        default: {
            const missingType = dto.type as number;
            Log.warn(
                `Unmapped External Dto IdType: '${missingType}'. mapPatientExternalIdToPatientSummaryExternalId function needs updating.`,
            );
            return undefined;
        }
    }
};

export const mapTicketPatientExternalIdsToPatientSummaryExternalIds = (
    dto: PatientExternalIdDto[] | null | undefined,
): PatientExternalId[] => {
    if (!dto) {
        return [];
    }

    return dto
        .map(mapPatientExternalIdToPatientSummaryExternalId)
        .filter(isInstance);
};
